import React, { MouseEventHandler, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../../ui/button/Button';

interface IPopupButton {
  onClick?: MouseEventHandler<HTMLDivElement>;
  style?: any;
  className?: any;
}

const PopupButton: React.FC<IPopupButton> = ({ onClick, style, className }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Lytter til scroll-event og oppdaterer isVisible basert på scroll-posisjonen
  const toggleVisibility = () => {
    console.log('scrolly', window.scrollY);
    if (window.scrollY >= 2000) {
      setIsVisible(false);
    } else if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Legger til event listener på mount og fjerner den på unmount
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <Popup style={style} className={className}>
      <Button
        className={`blikontaktet ${isVisible ? 'slide-in' : 'slide-out'}`}
        type="primary"
        colorTheme="gold"
        onClick={onClick}
      >
        Bli kontaktet
      </Button>
      {/*       <div
        className={`popup-button ${isVisible ? 'slide-in' : 'slide-out'}`}
        onClick={onClick}
      >
        Bli kontaktet
      </div> */}
    </Popup>
  );
};

const Popup = styled.div`
  .blikontaktet {
    position: fixed;
    right: -100px; /* Start utenfor skjermen */
    bottom: 50px;
    cursor: pointer;
    transition: right 0.5s ease-in-out;
  }

  /* Når klassen 'slide-in' er aktiv, flytt knappen inside skjermen */
  .blikontaktet.slide-in {
    right: 20px;
  }

  /* Når klassen 'slide-out' er aktiv, flytt knappen utenfor skjermen */
  .blikontaktet.slide-out {
    right: -150px;
    z-index: 999;
  }
`;

export default PopupButton;
